// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Button } from '@imprivata-cloud/components';
import { useTranslation } from 'react-i18next';
import EmptyStateIllustration from '../../../../assets/empty-list.svg';
import './ApplicationsEmpty.less';

const TRANSLATION_ROOT = 'apps';

interface ApplicationsEmptyProps {
  onAdd: () => void;
}

const ApplicationsEmpty = ({ onAdd }: ApplicationsEmptyProps) => {
  const { t } = useTranslation();

  return (
    <div className="applications-empty">
      <img src={EmptyStateIllustration} alt="" />
      <p>{t(`${TRANSLATION_ROOT}.empty.title`)}</p>
      <Button type="link" onClick={onAdd}>
        {t(`${TRANSLATION_ROOT}.empty.add-link`)}
      </Button>
    </div>
  );
};

export default ApplicationsEmpty;
